/*------------------------------------*\
    MODULES
\*------------------------------------*/
import CopyrightYear from './modules/copyright-year';
import DropdownMenu from './modules/dropdown-menu';
import Map from './modules/map';
import TypeMate from 'typemate';

/*------------------------------------*
    APP
\*------------------------------------*/
const app = {

    init() {
        this.noJs();
        this.alwaysLoad();
        this.nodelistPolyfill();
        this.bind();
    },

    bind() {

        // Load any items that need modules
        let modulePlaceHolders = [...document.querySelectorAll('[data-module]')];

        // No modules so bail
        if (!modulePlaceHolders.length) {
            return;
        }

        modulePlaceHolders.map((item) => {

            // Attempt to load any modules
            let modules = item.getAttribute('data-module');

            if (!modules.length) {
                return false;
            }

            // Split the modules into an array
            modules = modules.trim().split(',');

            // Loop and bind to relevant modules
            modules.map((module) => {

                switch (module.trim()) {

                    case 'copyright-year':

                        let copyrightYearInstance = new CopyrightYear(item);

                        copyrightYearInstance.init();

                        break;

                    case 'dropdown-menu':

                        let dropdownMenuInstance = new DropdownMenu(item);

                        dropdownMenuInstance.init();

                        break;

                    case 'map':

                        let mapInstance = new Map(item);

                        mapInstance.init();

                        break;
                }
            });
        });
    },

    alwaysLoad() {
        const typeMateElem = document.querySelector('body');
        const typeMateInstance = new TypeMate(typeMateElem, { selector: 'h1, h2, h3, h4, h5, h6, p' });
        typeMateInstance.apply();
    },

    noJs() {
        document.documentElement.classList.remove('no-js');
        document.documentElement.classList.add('js');
    },

    nodelistPolyfill() {
        if (window.NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = function (callback, thisArg) {
                thisArg = thisArg || window;
                for (var i = 0; i < this.length; i++) {
                    callback.call(thisArg, this[i], i, this);
                }
            };
        }
    }
};

// Launch
app.init();
